import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { EventContext } from "../../../contexts/EventContext";

const MatchWarning = () => {
  const { missingRounds, backToBackBreaks } = React.useContext(EventContext);

  const renderMissingRounds = () => {
    if (missingRounds) {
      let msg = "";
      try {
        if (missingRounds.length > 0) {
          for (var a of missingRounds) {
            msg =
              msg +
              `| ${a.attendee.profile.firstName} ${a.attendee.profile.lastName} \n`;
          }

          return (
            <Alert severity="warning">
              <AlertTitle>
                Warning - Some checked in attendees do not have matches
              </AlertTitle>
              {msg}
            </Alert>
          );
        } else {
          return <></>;
        }
      } catch (e) {
        var error = `Error: ${e.message}`;
        console.error(error);
        return <></>;
      }
    }
    return null;
  };

  const renderBackToBack = () => {
    if (backToBackBreaks) {
      let msg = "";
      try {
        if (backToBackBreaks.length > 0) {
          msg = backToBackBreaks.join(", ");

          return (
            <Alert severity="warning">
              <AlertTitle>
                Warning - Some attendees have back-to-back breaks
              </AlertTitle>
              {msg}
            </Alert>
          );
        } else {
          return <></>;
        }
      } catch (e) {
        var error = `Error: ${e.message}`;
        console.error(error);
        return <></>;
      }
    }
    return null;
  };

  return (
    <>
      {renderMissingRounds()}
      {renderBackToBack()}
    </>
  );
};

export default MatchWarning;
